// extracted by mini-css-extract-plugin
export default {"manager-name-cell-wrapper":"woKnnvJ8ThXw1ICQbmi9"};